/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetArticle200Response,
  GetBlogList200Response,
  GetCommonState400Response,
  GetInstruction404Response,
} from '../models/index'
import {
  GetArticle200ResponseFromJSON,
  GetArticle200ResponseToJSON,
  GetBlogList200ResponseFromJSON,
  GetBlogList200ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetInstruction404ResponseFromJSON,
  GetInstruction404ResponseToJSON,
} from '../models/index'

export interface GetArticleRequest {
  articleId: string
}

export interface GetBlogListRequest {
  page?: number
  perPage?: number
  categories?: Array<string>
}

/**
 * BlogApi - interface
 *
 * @export
 * @interface BlogApiInterface
 */
export interface BlogApiInterface {
  /**
   * Опубликованная статья блога по slug: полный конструктор контента, обложка и релевантные статьи. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * @summary Статья блога по slug
   * @param {string} articleId Slug статьи
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BlogApiInterface
   */
  getArticleRaw(
    requestParameters: GetArticleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetArticle200Response>>

  /**
   * Опубликованная статья блога по slug: полный конструктор контента, обложка и релевантные статьи. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * Статья блога по slug
   */
  getArticle(
    requestParameters: GetArticleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetArticle200Response>

  /**
   * Список опубликованных статей блога: карточки с пагинацией и фильтром по категориям, плюс список категорий блога. Ответ кэшируется в Redis.
   * @summary Список статей блога
   * @param {number} [page] Номер страницы (по умолчанию 1)
   * @param {number} [perPage] Статей на странице (по умолчанию 10)
   * @param {Array<string>} [categories] Фильтр по названиям категорий
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BlogApiInterface
   */
  getBlogListRaw(
    requestParameters: GetBlogListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetBlogList200Response>>

  /**
   * Список опубликованных статей блога: карточки с пагинацией и фильтром по категориям, плюс список категорий блога. Ответ кэшируется в Redis.
   * Список статей блога
   */
  getBlogList(
    requestParameters: GetBlogListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetBlogList200Response>
}

/**
 *
 */
export class BlogApi extends runtime.BaseAPI implements BlogApiInterface {
  /**
   * Опубликованная статья блога по slug: полный конструктор контента, обложка и релевантные статьи. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * Статья блога по slug
   */
  async getArticleRaw(
    requestParameters: GetArticleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetArticle200Response>> {
    if (requestParameters['articleId'] == null) {
      throw new runtime.RequiredError(
        'articleId',
        'Required parameter "articleId" was null or undefined when calling getArticle().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/blog/{articleId}`.replace(
          `{${'articleId'}}`,
          encodeURIComponent(String(requestParameters['articleId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetArticle200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Опубликованная статья блога по slug: полный конструктор контента, обложка и релевантные статьи. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * Статья блога по slug
   */
  async getArticle(
    requestParameters: GetArticleRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetArticle200Response> {
    const response = await this.getArticleRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Список опубликованных статей блога: карточки с пагинацией и фильтром по категориям, плюс список категорий блога. Ответ кэшируется в Redis.
   * Список статей блога
   */
  async getBlogListRaw(
    requestParameters: GetBlogListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetBlogList200Response>> {
    const queryParameters: any = {}

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    if (requestParameters['categories'] != null) {
      queryParameters['categories'] = requestParameters['categories']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/blog`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetBlogList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список опубликованных статей блога: карточки с пагинацией и фильтром по категориям, плюс список категорий блога. Ответ кэшируется в Redis.
   * Список статей блога
   */
  async getBlogList(
    requestParameters: GetBlogListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetBlogList200Response> {
    const response = await this.getBlogListRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
